import { ChannelManager } from '@ayocore/erp/crm/client/components/ChannelManager';
import type { ContactChannel } from '../../../../../schemas/contact-channel.schema';

interface PartnerChannelsProps {
  entityUuid: string;
  contactChannels: ContactChannel[];
  onChannelsChanged: () => void;
  /** Можно ли заводить новые каналы. По умолчанию — да. */
  canAdd?: boolean;
  /** Можно ли править конкретный канал. По умолчанию — да. */
  canEditChannel?: (channel: ContactChannel) => boolean;
}

export function PartnerChannels({
  entityUuid,
  contactChannels,
  onChannelsChanged,
  canAdd,
  canEditChannel,
}: PartnerChannelsProps) {
  return (
    <ChannelManager
      entityUuid={entityUuid}
      contactChannels={contactChannels}
      onChannelsChanged={onChannelsChanged}
      canAdd={canAdd}
      canEditChannel={canEditChannel}
    />
  );
}
